export default __webpack_public_path__ + "static/media/DSC08887.5a728269.jpg";